import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

/** Header to skip the global loader for this request (e.g. background/polling). */
export const SKIP_LOADER_HEADER = 'X-Skip-Loader';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  if (req.url.includes('connect/token') || req.url.includes('refresh_token')) {
    return next(req);
  }
  if (req.headers.get(SKIP_LOADER_HEADER) === 'true') {
    const cloned = req.clone({
      headers: req.headers.delete(SKIP_LOADER_HEADER),
    });
    return next(cloned);
  }

  loadingService.show();
  return next(req).pipe(
    finalize(() => {
      loadingService.hide();
    })
  );
};
